import { Button, Flex, Text } from '@nula/core-ui';
import styles from './tentative-batch-toast.module.css';

export interface TentativeBatchToastProps {
  /** Number of tentative-real entity-proxy nodes on the canvas. */
  count: number;
  /** Called when the user clicks "Accept all". */
  onAcceptAll: () => void;
}

/**
 * TentativeBatchToast
 *
 * Rendered at the bottom-center of the canvas viewport whenever there is at
 * least one real-tentative entity-proxy node (tentative=true, isVirtual=false).
 *
 * Per client.md §16: any tentative count triggers the toast — no minimum
 * threshold. Visibility is determined by the parent: if count is 0, return null.
 *
 * The parent (CanvasDocumentMount) positions this inside an absolute overlay
 * div: bottom-center, z-index: var(--z-toast).
 */
export function TentativeBatchToast({
  count,
  onAcceptAll,
}: TentativeBatchToastProps) {
  // Per client.md §16: any tentative count triggers the toast.
  if (count <= 0) return null;

  return (
    <div className={styles.toast}>
      <Flex gap="md" align="center">
        <Text size="sm">{count} tentative {count === 1 ? 'node' : 'nodes'}</Text>
        <Button onClick={onAcceptAll}>Accept all</Button>
      </Flex>
    </div>
  );
}
